$('.safety-question').on('click', function (e) {
    e.preventDefault();

    let link = $(this).attr('href');
    let text = getText($(this).attr('data-text'));

    showSweetAlert(text, link);

});

function showSweetAlert(text, link) {
    Swal.fire({
        width: 800,
        title: 'Sicherheitsabfrage',
        text: 'Möchten Sie den Lauf jetzt starten?',
        icon: 'info',
        footer: '<p class="text-left">'+text+'</p>',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Abbrechen',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
        cancelButtonColor: '#d33'
    }).then((result) => {
        if (result.value) {
            window.location.href = link
        }
    });
}

function getText(text) {
    if(text === undefined) {
        return 'Beispieltext';
    } else {
        return text;
    }
}
